import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import { Link } from "react-router-dom";
import api from "utils/API";
import { days_open } from "components/Request/ManageRequest/DaysOpen";
import moment from "moment";

const ReceptionInfo = props => {
  const [order, setOrder] = useState([]);
  const [patients, setPatients] = useState([]);

  useEffect(() => {
    api.get(`api/solicitudpedidos/${props.id}`).then(result => {
      setOrder(result.data);
    });
    api.get("api/paciente/").then(result => {
      setPatients(result.data);
    });
  }, []);

  const getPatient = (id, patients) => {
    const response = patients
      .filter(patient => patient.id === id)
      .map(filtered => {
        return filtered.nombre;
      });
    return response;
  };

  const months_open = date => {
    const today = moment(new Date()).format("DD/MM/YYYY");
    const request_date = moment(date).format("DD/MM/YYYY");
    const diff = moment(today, "DD/MM/YYYY").diff(
      moment(request_date, "DD/MM/YYYY")
    );
    const duration = moment.duration(diff);
    return duration._data.months;
  };

  return (
    <div className="col-xl-8 mb-3">
      <div className="card">
        <div className="card-header">
          <p className="text-center">Datos del pedido</p>
          {/* <div className="row">
            <div className="col" />
            <div className="col-6">
              <p className="text-center">Datos del pedido</p>
            </div>
          </div> */}
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-sm text-left ml-5">
              <span className="font-weight-bold">Id: </span>
              {props.id}
              <br />
              <span className="font-weight-bold">Tipo de solicitud: </span>
              {order.tipo_solicitud}
              <br />
              <span className="font-weight-bold">Paciente: </span>
              {getPatient(order.id_paciente, patients)}
            </div>
            <div className="col-sm text-left">
              <span className="font-weight-bold">Fecha solicitud: </span>
              {order.fecha_solicitud}
              <br />
              <span className="font-weight-bold">Fecha a despachar: </span>
              {order.fecha_despacho}
              <br />
              <span className="font-weight-bold">Región: </span>
              {order.es_region ? "Si" : "No"}
            </div>
            <div className="col-sm text-left">
              <span className="font-weight-bold">Estado picking: </span>
              {order.estado_picking}
              <br />
              <span className="font-weight-bold">Días de atraso: </span>
              Meses: {months_open(order.fecha_solicitud)}
               /  Días:
              {days_open(order.fecha_solicitud)}
              <br />
              <span className="font-weight-bold">Medicamento: </span>
              {order.tiene_medicamentos ? "Si" : "No"}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReceptionInfo;

ReceptionInfo.propTypes = {
  title: PropTypes.string,
  closeModal: PropTypes.bool,
  id_therapy: PropTypes.number,
  id_paquetizacion: PropTypes.number,
  id: PropTypes.number
};
